"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ConvertModule = /** @class */ (function () {
    function ConvertModule() {
    }
    ConvertModule.BaseItemToArrayString = function (elements) {
        var list = new Array();
        try {
            if (elements) {
                list = elements.map(function (value) {
                    return value.Name;
                });
            }
        }
        catch (error) {
            console.log("Error BaseItemToArrayString", error);
        }
        return list;
    };
    ConvertModule.BaseItemToArrayInt = function (elements) {
        var list = new Array();
        try {
            if (elements) {
                list = elements.map(function (value) {
                    return value.Id;
                });
            }
        }
        catch (error) {
            console.log("Error BaseItemToArrayInt", error);
        }
        return list;
    };
    return ConvertModule;
}());
exports.default = ConvertModule;
//# sourceMappingURL=ConvertModule.js.map